import { getCDNUrl } from "./utils/cdnUtils";
import improvingPdf from "./assets/RL24_Lflt1_MRT_Palestine_WEB.pdf";
import covidPdf from "./assets/RL24_Lflt2_Sudan_Palestine_WEB.pdf";
import wasteWaterPdf from "./assets/RL24_Lflt7_Guinea_Morocco_WEB.pdf";
import enhancePdf from "./assets/RL24_Lflt3_Somalia_Yemen_WEB.pdf";
import telemedcinePdf from "./assets/RL24_Lflt4_Somalia_Egypt_WEB.pdf";
import utalizePdf from "./assets/RL24_Lflt5_Indonesia_Singapore_WEB.pdf";
import strenghtPdf from "./assets/RL24_Lflt6_Tunisia_Brasil_WEB.pdf";
import improvingImg from "./assets/Improving Production.jpg";
import covidImg from "./assets/Responding to.jpg";
import utalizeImg from "./assets/Utilizing Artificial.jpg";
import enhanceImg from "./assets/Enhancing the Provision.png";
import wasteWaterImg from "./assets/wasteWater.png";
import telemedcineImg from "./assets/improvingHealth.png";
import strenghtImg from "./assets/strenght.png";

export const SliderProjects = [
  {
    title: "Improving Production and Productivity of Vegetables",
    file: getCDNUrl(improvingPdf),
    img: getCDNUrl(improvingImg)
  },
  {
    title: "Responding to Covid-19 Pandemic in Collaboration with Diaspora",
    file: getCDNUrl(covidPdf),
    img: getCDNUrl(covidImg)
  },
  {
    title: "Wastewater Treatment Development Project in Conakry",
    file: getCDNUrl(wasteWaterPdf),
    img: getCDNUrl(wasteWaterImg)
  },
  {
    title: "Improving Health Services Through Telemedicine",
    file: getCDNUrl(telemedcinePdf),
    img: getCDNUrl(telemedcineImg)
  },
  {
    title: "Utilizing Artificial Intelligence And Advanced",
    file: getCDNUrl(utalizePdf),
    img: getCDNUrl(utalizeImg)
  },
  {
    title: "Strengthening Global Capacity Development",
    file: getCDNUrl(strenghtPdf),
    img: getCDNUrl(strenghtImg)
  },
  {
    title: "Enhancing the Provision of Microfinance Services",
    file: getCDNUrl(enhancePdf),
    img: getCDNUrl(enhanceImg)
  }
];
